module.exports = __webpack_public_path__ + "img/0004.2139525d.gif";